module.exports = __webpack_public_path__ + "img/spartan-sheetrock-framing-texture-03.9d1331b7.jpg";